// @flow
import * as React from "react";
import styled from 'styled-components';
import numeral from 'numeral';
import * as _ from 'lodash';


import colors from '../../../assets/css/colors';
import { below } from "../../../assets/css/media";
import { getActivePlayerIdsForRound } from '../../../helpers/team/getActivePlayerIdsForRound';

const PlayersStatus = styled.div`
	font-size: 12px;
	text-align: center;
	line-height: 1.5;
	margin: 0 14px;
	p {
		font-weight: normal;
	}


	.isMobile {
		display: none;
		${below.desktop`
			display: inline-block;
		`};
	}

	.isDesktop {
		${below.desktop`
			display: none;
		`};
	}
`;

const CountPlayers = styled.span`
	font-weight: 700;
	color: ${colors.title};
`;

const PlayersInfoWrapper = styled.div`
	padding: 12px 16px;
	background: ${colors.lightGreen};
	color: ${colors.title};
	display: flex;
	flex: 1;
	flex-direction: ${({ right_align }) => right_align ? 'row-reverse' : 'row'};

	${below.desktop`
		justify-content: flex-start;
	`};

	${PlayersStatus} {
		${below.desktop`
			font-size: 12px;
			margin-right: ${({ right_align }) => right_align ? '0' : '3px'};
			margin-left: ${({ right_align }) => right_align ? '3px' : '0'};
		`};

		${below.tablet`
			font-size: 10px;
		`};
	}
`;

type Props = {
	opponent: Object,
	players_by_id: Object,
	round: Object,
	right_align?: boolean,
};

const getMatchDataFromPlayerId = (player_id, round, players_by_id) => {
	const player = players_by_id[player_id];
	if(!player) {
		return {};
	}
	const match = round.matches.find(match => match.home_squad_id === player.squad_id ||
		match.away_squad_id === player.squad_id);
	return match;
};

export const PlayersInfo = ({ opponent, right_align, players_by_id, round }: Props) => {
	// $FlowFixMe
	if(_.isEmpty(round) || _.isEmpty(players_by_id) || _.isEmpty(opponent)) {
		return [];
	}

	const active_players_switch = {
		"scheduled": _.chain(opponent.lineup)
			.omit(['emergency', 'captain', 'vice_captain', 'bench'])
			.map(row => row)
			.reduce((row, all) => [...row, ...all], [])
			.value(),
		"playing": getActivePlayerIdsForRound(opponent.lineup, players_by_id, round),
		"active": getActivePlayerIdsForRound(opponent.lineup, players_by_id, round),
		"complete": getActivePlayerIdsForRound(opponent.lineup, players_by_id, round)
	};

	const active_players = _.result(active_players_switch, round.status);

	const players_with_match_data = active_players.map(player_id =>
		getMatchDataFromPlayerId(player_id, round, players_by_id));

	const yet_to_play = players_with_match_data
		.filter(player_match_data =>
			player_match_data && player_match_data.status === 'scheduled').length;

	const playing_now_matches = players_with_match_data
		.filter(player_match_data =>
			player_match_data && player_match_data.status === 'playing');
	const playing_now = playing_now_matches.length;

	const complete = players_with_match_data
		.filter(player_match_data =>
			player_match_data && player_match_data.status === 'complete').length;

	const total = active_players.length;

	const seconds_remaining = playing_now_matches.reduce((acc_mins, current_match) => {
		if(!current_match.clock) {
			return 0;
		}
		const time_gone = current_match.clock.p === 'H2'?
			2400 + current_match.clock.s : current_match.clock.s;
		return (80 * 60) - time_gone;
	}, 0) + yet_to_play * 4800;

	const mins_remaining = seconds_remaining / 60;


	return <PlayersInfoWrapper right_align={right_align}>
		<PlayersStatus color={colors.title}>
			<p>Mins Remaining</p><br />
			<CountPlayers>{numeral(mins_remaining).format('0')}/{total * 80}</CountPlayers>
		</PlayersStatus>
		<PlayersStatus color={colors.title}>
			<p>Final</p><br />
			<CountPlayers>{numeral(complete).format("0")}</CountPlayers>
		</PlayersStatus>
		<PlayersStatus color={colors.title}>
			<p>Live</p><br />
			<CountPlayers>{numeral(playing_now).format("0")}</CountPlayers>
		</PlayersStatus>
		<PlayersStatus color={colors.title}>
			<p>YTP</p><br />
			<CountPlayers>{numeral(yet_to_play).format("0")}</CountPlayers>
		</PlayersStatus>
	</PlayersInfoWrapper>;
};

export default PlayersInfo;


// WEBPACK FOOTER //
// ./src/pages/league/matchup/playersInfo.js